// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2wsgr","label":"Completed_label__2B4uS"};